import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import SecondShare from './secondShare';

const Layout = () => {
    return (
        <div className={styles.layout}>
            <div className={styles.banner}>
                <img className={styles.bannerImg} src="https://x0.ifengimg.com/ucms/2025_24/B9C28B885DDAA1BEC6AC69DB9F325DBF924B88E5_size1070_w750_h1090.png" />
            </div>
            <img className={styles.bottomInfo} src="https://x0.ifengimg.com/ucms/2025_24/E1A2EE60F2A46E9F49C41C2B1F9FFC70EE4D88D8_size8_w288_h48.png" />
            <div className={styles.buttonlist}>
                <a href="https://ishare.ifeng.com/loc/phtvHostColleges2025">
                    <img className={styles.button} src="https://x0.ifengimg.com/ucms/2025_24/5461570ED05EF2495B53186F7D423DE4A110C478_size24_w216_h84.png" />
                </a>
                <a href="https://ishare.ifeng.com/loc/phtvHostSociety2025">
                    <img className={styles.button} src="https://x0.ifengimg.com/ucms/2025_24/6691E74E649DC8677EA7D5490AEB728A394B9E0B_size24_w216_h84.png" />
                </a>
                <a href="https://ishare.ifeng.com/loc/phtvHostArea2025">
                    <img className={styles.button} src="https://x0.ifengimg.com/ucms/2025_24/13A5ED585004CEBAC6991E8E77D50471E4CD9A4D_size25_w224_h84.png" />
                </a>
            </div>
            <SecondShare />
        </div>
    );
};

export default errorBoundary(Layout);
